import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@frontierag/frontier-ui-library';
import { Business as BusinessIcon, Star as StarIcon } from '@frontierag/frontier-ui-library/icons';

import { styles } from './styles';

export default function GroupCustomers({
  group,
  children,
}: {
  group: string;
  children: ReactNode;
}) {
  const { t } = useTranslation('Customers');

  return (
    <>
      <Box sx={styles.group} data-testid="grouped-customers-select">
        <Box color="naval.L40" height={24}>
          {group === 'mostUsed' ? <StarIcon /> : <BusinessIcon />}
        </Box>
        {t(`groups.${group}`)}
      </Box>
      <Box sx={styles.row}>{children}</Box>
    </>
  );
}
